// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: QPDKwEQ9D_
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicSample.module.css"; // plasmic-import: QPDKwEQ9D_/css
import Line11Icon from "./icons/PlasmicIcon__Line11"; // plasmic-import: XnX7WNKQoD/icon
import VisaLogoIcon from "./icons/PlasmicIcon__VisaLogo"; // plasmic-import: 7K5fK8A_L_/icon
import AmexIcon from "./icons/PlasmicIcon__Amex"; // plasmic-import: 6rdvSv-25y/icon
import Line9Icon from "./icons/PlasmicIcon__Line9"; // plasmic-import: NhE9g4w6B/icon
import mastercard3K3P90Bxlf from "./images/mastercard.svg"; // plasmic-import: 3k3P90Bxlf/picture
import discover2Zsp5Mijrz from "./images/discover2.svg"; // plasmic-import: -Zsp5mijrz/picture

createPlasmicElementProxy;

export const PlasmicSample__VariantProps = new Array();

export const PlasmicSample__ArgProps = new Array();

const $$ = {};

function PlasmicSample__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  return (
    <div
      data-plasmic-name={"center"}
      data-plasmic-override={overrides.center}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.center
      )}
    >
      <div
        data-plasmic-name={"figmaPaste"}
        data-plasmic-override={overrides.figmaPaste}
        className={classNames(projectcss.all, sty.figmaPaste)}
      >
        <p.Stack
          as={"div"}
          data-plasmic-name={"inputField"}
          data-plasmic-override={overrides.inputField}
          hasGap={true}
          className={classNames(projectcss.all, sty.inputField)}
        >
          <div
            data-plasmic-name={"cardNumber2"}
            data-plasmic-override={overrides.cardNumber2}
            className={classNames(projectcss.all, sty.cardNumber2)}
          >
            <div
              data-plasmic-name={"_1234123412341234"}
              data-plasmic-override={overrides._1234123412341234}
              className={classNames(projectcss.all, sty._1234123412341234)}
            >
              <input
                data-plasmic-name={"cardNumber"}
                data-plasmic-override={overrides.cardNumber}
                aria-label={""}
                className={classNames(
                  projectcss.all,
                  projectcss.input,
                  sty.cardNumber
                )}
                disabled={false}
                id={"cardNumber"}
                placeholder={"1234 1234 1234 1234"}
                ref={ref => {
                  $refs["cardNumber"] = ref;
                }}
                size={1}
                title={""}
                type={"text"}
                value={""}
              />

              <Line11Icon
                className={classNames(projectcss.all, sty.svg__e9Ze4)}
                role={"img"}
              />
            </div>
            <div
              data-plasmic-name={"paymentMethodVisa"}
              data-plasmic-override={overrides.paymentMethodVisa}
              className={classNames(projectcss.all, sty.paymentMethodVisa)}
            >
              <div
                data-plasmic-name={"base"}
                data-plasmic-override={overrides.base}
                className={classNames(projectcss.all, sty.base)}
              >
                <VisaLogoIcon
                  className={classNames(projectcss.all, sty.svg__eBmgL)}
                  role={"img"}
                />
              </div>
            </div>
            <div
              data-plasmic-name={"icon"}
              data-plasmic-override={overrides.icon}
              className={classNames(projectcss.all, sty.icon)}
            />

            <div
              data-plasmic-name={"paymentMethodMastercard"}
              data-plasmic-override={overrides.paymentMethodMastercard}
              className={classNames(
                projectcss.all,
                sty.paymentMethodMastercard
              )}
            >
              <div
                data-plasmic-name={"base2"}
                data-plasmic-override={overrides.base2}
                className={classNames(projectcss.all, sty.base2)}
              >
                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__x9VRf)}
                  displayHeight={"11.3px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"17.33px"}
                  loading={"lazy"}
                  src={{
                    src: mastercard3K3P90Bxlf,
                    fullWidth: 19.928,
                    fullHeight: 12.228,
                    aspectRatio: 1.538462
                  }}
                />
              </div>
            </div>
            <div
              data-plasmic-name={"icon2"}
              data-plasmic-override={overrides.icon2}
              className={classNames(projectcss.all, sty.icon2)}
            />

            <div
              data-plasmic-name={"paymentMethodAmex"}
              data-plasmic-override={overrides.paymentMethodAmex}
              className={classNames(projectcss.all, sty.paymentMethodAmex)}
            >
              <div
                data-plasmic-name={"base3"}
                data-plasmic-override={overrides.base3}
                className={classNames(projectcss.all, sty.base3)}
              >
                <AmexIcon
                  className={classNames(projectcss.all, sty.svg__df4WS)}
                  role={"img"}
                />
              </div>
            </div>
            <div
              data-plasmic-name={"icon3"}
              data-plasmic-override={overrides.icon3}
              className={classNames(projectcss.all, sty.icon3)}
            />

            <div
              data-plasmic-name={"paymentMethodDiscover"}
              data-plasmic-override={overrides.paymentMethodDiscover}
              className={classNames(projectcss.all, sty.paymentMethodDiscover)}
            >
              <div
                data-plasmic-name={"base4"}
                data-plasmic-override={overrides.base4}
                className={classNames(projectcss.all, sty.base4)}
              >
                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__vwdHz)}
                  displayHeight={"11.5px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"23.5px"}
                  loading={"lazy"}
                  src={{
                    src: discover2Zsp5Mijrz,
                    fullWidth: 26.571,
                    fullHeight: 12.4,
                    aspectRatio: 2.076923
                  }}
                />
              </div>
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__tkdq)}>
            <input
              data-plasmic-name={"expDate"}
              data-plasmic-override={overrides.expDate}
              aria-label={""}
              className={classNames(
                projectcss.all,
                projectcss.input,
                sty.expDate
              )}
              id={"expDate"}
              placeholder={"MM / YY"}
              ref={ref => {
                $refs["expDate"] = ref;
              }}
              size={1}
              type={"text"}
              value={""}
            />

            <input
              data-plasmic-name={"cvv"}
              data-plasmic-override={overrides.cvv}
              aria-label={""}
              className={classNames(projectcss.all, projectcss.input, sty.cvv)}
              id={"cvv"}
              placeholder={"CVC"}
              ref={ref => {
                $refs["cvv"] = ref;
              }}
              size={1}
              type={"text"}
              value={""}
            />
          </div>
        </p.Stack>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__psrdc
          )}
        >
          {"Card Information"}
        </div>
        <Line9Icon
          className={classNames(projectcss.all, sty.svg__jhcze)}
          role={"img"}
        />
      </div>
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__myVcp
        )}
      >
        {"Billing Address"}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__r9Sko)}>
        <div
          data-plasmic-name={"countryStack"}
          data-plasmic-override={overrides.countryStack}
          className={classNames(projectcss.all, sty.countryStack)}
        />

        <input
          data-plasmic-name={"address"}
          data-plasmic-override={overrides.address}
          className={classNames(projectcss.all, projectcss.input, sty.address)}
          placeholder={"Address"}
          ref={ref => {
            $refs["address"] = ref;
          }}
          size={1}
          type={"text"}
          value={""}
        />

        <div className={classNames(projectcss.all, sty.freeBox__i4ED3)}>
          <input
            data-plasmic-name={"city"}
            data-plasmic-override={overrides.city}
            className={classNames(projectcss.all, projectcss.input, sty.city)}
            placeholder={"City"}
            ref={ref => {
              $refs["city"] = ref;
            }}
            size={1}
            type={"text"}
            value={""}
          />

          <input
            data-plasmic-name={"zip"}
            data-plasmic-override={overrides.zip}
            className={classNames(projectcss.all, projectcss.input, sty.zip)}
            placeholder={"ZIP"}
            ref={ref => {
              $refs["zip"] = ref;
            }}
            size={1}
            type={"text"}
            value={""}
          />
        </div>
        <div
          data-plasmic-name={"stateStack"}
          data-plasmic-override={overrides.stateStack}
          className={classNames(projectcss.all, sty.stateStack)}
        />
      </div>
      <div
        data-plasmic-name={"payButton"}
        data-plasmic-override={overrides.payButton}
        className={classNames(projectcss.all, sty.payButton)}
        id={"credit-card-submit"}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__u8ZIo
          )}
        >
          {"Pay"}
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  center: [
    "center",
    "figmaPaste",
    "inputField",
    "cardNumber2",
    "_1234123412341234",
    "cardNumber",
    "paymentMethodVisa",
    "base",
    "icon",
    "paymentMethodMastercard",
    "base2",
    "icon2",
    "paymentMethodAmex",
    "base3",
    "icon3",
    "paymentMethodDiscover",
    "base4",
    "expDate",
    "cvv",
    "countryStack",
    "address",
    "city",
    "zip",
    "stateStack",
    "payButton"
  ],

  figmaPaste: [
    "figmaPaste",
    "inputField",
    "cardNumber2",
    "_1234123412341234",
    "cardNumber",
    "paymentMethodVisa",
    "base",
    "icon",
    "paymentMethodMastercard",
    "base2",
    "icon2",
    "paymentMethodAmex",
    "base3",
    "icon3",
    "paymentMethodDiscover",
    "base4",
    "expDate",
    "cvv"
  ],

  inputField: [
    "inputField",
    "cardNumber2",
    "_1234123412341234",
    "cardNumber",
    "paymentMethodVisa",
    "base",
    "icon",
    "paymentMethodMastercard",
    "base2",
    "icon2",
    "paymentMethodAmex",
    "base3",
    "icon3",
    "paymentMethodDiscover",
    "base4",
    "expDate",
    "cvv"
  ],

  cardNumber2: [
    "cardNumber2",
    "_1234123412341234",
    "cardNumber",
    "paymentMethodVisa",
    "base",
    "icon",
    "paymentMethodMastercard",
    "base2",
    "icon2",
    "paymentMethodAmex",
    "base3",
    "icon3",
    "paymentMethodDiscover",
    "base4"
  ],

  _1234123412341234: ["_1234123412341234", "cardNumber"],
  cardNumber: ["cardNumber"],
  paymentMethodVisa: ["paymentMethodVisa", "base"],
  base: ["base"],
  icon: ["icon"],
  paymentMethodMastercard: ["paymentMethodMastercard", "base2"],
  base2: ["base2"],
  icon2: ["icon2"],
  paymentMethodAmex: ["paymentMethodAmex", "base3"],
  base3: ["base3"],
  icon3: ["icon3"],
  paymentMethodDiscover: ["paymentMethodDiscover", "base4"],
  base4: ["base4"],
  expDate: ["expDate"],
  cvv: ["cvv"],
  countryStack: ["countryStack"],
  address: ["address"],
  city: ["city"],
  zip: ["zip"],
  stateStack: ["stateStack"],
  payButton: ["payButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSample__ArgProps,
          internalVariantPropNames: PlasmicSample__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSample__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "center") {
    func.displayName = "PlasmicSample";
  } else {
    func.displayName = `PlasmicSample.${nodeName}`;
  }
  return func;
}

export const PlasmicSample = Object.assign(
  // Top-level PlasmicSample renders the root element
  makeNodeComponent("center"),
  {
    // Helper components rendering sub-elements
    figmaPaste: makeNodeComponent("figmaPaste"),
    inputField: makeNodeComponent("inputField"),
    cardNumber2: makeNodeComponent("cardNumber2"),
    _1234123412341234: makeNodeComponent("_1234123412341234"),
    cardNumber: makeNodeComponent("cardNumber"),
    paymentMethodVisa: makeNodeComponent("paymentMethodVisa"),
    base: makeNodeComponent("base"),
    icon: makeNodeComponent("icon"),
    paymentMethodMastercard: makeNodeComponent("paymentMethodMastercard"),
    base2: makeNodeComponent("base2"),
    icon2: makeNodeComponent("icon2"),
    paymentMethodAmex: makeNodeComponent("paymentMethodAmex"),
    base3: makeNodeComponent("base3"),
    icon3: makeNodeComponent("icon3"),
    paymentMethodDiscover: makeNodeComponent("paymentMethodDiscover"),
    base4: makeNodeComponent("base4"),
    expDate: makeNodeComponent("expDate"),
    cvv: makeNodeComponent("cvv"),
    countryStack: makeNodeComponent("countryStack"),
    address: makeNodeComponent("address"),
    city: makeNodeComponent("city"),
    zip: makeNodeComponent("zip"),
    stateStack: makeNodeComponent("stateStack"),
    payButton: makeNodeComponent("payButton"),
    // Metadata about props expected for PlasmicSample
    internalVariantProps: PlasmicSample__VariantProps,
    internalArgProps: PlasmicSample__ArgProps
  }
);

export default PlasmicSample;
/* prettier-ignore-end */
